var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthscreenBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#a9a9a9;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.568,5.051A1.257,1.257,0,1,1,13.355,6.82L4.294,15.882H34.2a1.259,1.259,0,0,1,1.269,1.251A1.274,1.274,0,0,1,34.2,18.4H4.294l9.062,9.045a1.283,1.283,0,0,1,0,1.787,1.252,1.252,0,0,1-1.787,0L.362,18.027a1.261,1.261,0,0,1,0-1.769Z",
    transform: "translate(2.531 3.209)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthscreenBackIcon);
export default __webpack_public_path__ + "static/media/authscreen-back-icon.2b4f56ad4eda53eebfbffcc5d9d9bbf7.svg";
export { ForwardRef as ReactComponent };